<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="titlea">THE</h1>
<h1 class="title"><span class="bold">SINKING</span></h1>
<h1 class="titleb">OF THE</h1>
<h1 class="title1"><span class="bold">BLÜCHER</span></h1>
<p class="subtitle"><span class="bold">THE BATTLE OF DRØBAK NARROWS APRIL 1940</span></p>
<div class="img_container" id="pgiiiimg1">
<img alt="images" src="images/f0iii-01.jpg"/>
</div>
<p class="author"><span class="bold">Geirr Haarr and Tor Jørgen Melien</span></p>
<div class="img_containert">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?4d32ef43